import { useEffect } from "react";

export default function ExcludeBehaviour(){

  useEffect(() => {
    // Theme: localStorage + toggles are handled by static/js/common/app-core.js (initAuthThemeSwitch / setTheme).
    // ================================
    // ✅ PURCHASE PRICE + LOAN AMOUNT COMMA FORMAT
    // ================================
    ["purchasePriceInput", "loanInput", "currentPriceInput"].forEach(id => {

      const input = document.getElementById(id);

      if (input) {
        input.addEventListener("input", function () {

          let value = this.value.replace(/,/g, ""); // remove commas

          if (!isNaN(value) && value !== "") {

            // Indian format
            const formatted = new Intl.NumberFormat("en-IN").format(value);

            this.value = formatted;
          }
        });
      }
    // ================================
    // ✅ PURCHASE PRICE + LOAN AMOUNT DIGIT ONLY
    // ================================
    const allowOnlyDigits = (input) => {

      if (input.dataset.onlyDigits) return; // prevent duplicate
      input.dataset.onlyDigits = "true";

      input.addEventListener("input", function () {
        this.value = this.value.replace(/\D/g, ""); // remove non-digits
      });

      input.addEventListener("keypress", function (e) {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      });
    };
    // ================================
    // ✅ APPLY HERE ( DIGIT ONLY FUNCTION)
    // ================================
    const priceInput = document.getElementById("purchasePriceInput");
    const currentPriceInput = document.getElementById("currentPriceInput");
    const loanInput = document.getElementById("loanInput");

    if (currentPriceInput) allowOnlyDigits(currentPriceInput);
    if (priceInput) allowOnlyDigits(priceInput);
    if (loanInput) allowOnlyDigits(loanInput);
});
  }, []);

  return null;
}
